import React from 'react'

export const StoreContext = React.createContext()

export const RouterContext = React.createContext()
